module.exports = __webpack_public_path__ + "img/amazon.14e093e3.png";